module.exports = __webpack_public_path__ + "static/media/13.b62242d4.png";